import {ChangeDetectorRef, Component, ElementRef, forwardRef} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractColorPairInput} from "../abstract-color-pair-input";
import {TranslateService} from "@ngx-translate/core";
import {FUIEventsService} from "../../../../events/events.service";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIInlineColorPairInputComponent),
            multi: true
        }
    ],
    selector: "fui-inline-color-pair-input",
    styleUrls: ["./inline-color-pair-input.component.scss"],
    templateUrl: "./inline-color-pair-input.component.html"
})
export class FUIInlineColorPairInputComponent extends FUIAbstractColorPairInput {
    constructor(elementRef: ElementRef,
                eventsService: FUIEventsService,
                translateService: TranslateService,
                changeDetectorRef: ChangeDetectorRef) {
        super(elementRef, eventsService, translateService, changeDetectorRef);
    }
}
